import { render, staticRenderFns } from "./statisticalQuery.vue?vue&type=template&id=0522a199&scoped=true&"
import script from "./statisticalQuery.vue?vue&type=script&lang=js&"
export * from "./statisticalQuery.vue?vue&type=script&lang=js&"
import style0 from "./statisticalQuery.vue?vue&type=style&index=0&id=0522a199&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0522a199",
  null
  
)

export default component.exports